import * as Yup from 'yup';
import { phoneRegex } from "helpers/helpers";

export const getNewValidationSchema = (intl) =>
    Yup.object().shape({
        contactFirstName: Yup.string().required(intl.formatMessage({ id: 'validation.required' })).nullable(),
        contactLastName: Yup.string().required(intl.formatMessage({ id: 'validation.required' })).nullable(),
        contactEmail: Yup.string()
            .email(intl.formatMessage({ id: 'validation.email' }))
            .required(intl.formatMessage({ id: 'validation.required' })).nullable(),
        name: Yup.string().required(intl.formatMessage({ id: 'validation.required' })).nullable(),
        companyId: Yup.string().required(intl.formatMessage({ id: 'validation.required' })).nullable(),
        segmentId: Yup.string().required(intl.formatMessage({ id: 'validation.required' })).nullable(),
        postal: Yup.string()
            .matches(/^[0-9]+$/, intl.formatMessage({ id: 'validation.number' }))
            .min(5, intl.formatMessage({ id: 'validation.string.exact' }, [5]))
            .max(5, intl.formatMessage({ id: 'validation.string.exact' }, [5]))
            .nullable(),
        contactPhone: Yup.string()
            .matches(phoneRegex, intl.formatMessage({ id: 'validation.phoneNumber' }))
            .matches(/^[+,0-9]+$/, intl.formatMessage({ id: 'validation.phoneNumber' }))
            .nullable(),
        latitude: Yup.number()
            .required(intl.formatMessage({ id: 'validation.required' }))
            .typeError(intl.formatMessage({ id: 'validation.number' })),
        longtitude: Yup.number()
            .required(intl.formatMessage({ id: 'validation.required' }))
            .typeError(intl.formatMessage({ id: 'validation.number' })),

    });

export const getDetailValidationSchema = (intl) =>
    Yup.object().shape({
        contactFirstName: Yup.string().required(intl.formatMessage({ id: 'validation.required' })).nullable(),
        contactLastName: Yup.string().required(intl.formatMessage({ id: 'validation.required' })).nullable(),
        name: Yup.string().required(intl.formatMessage({ id: 'validation.required' })).nullable(),
        contactEmail: Yup.string()
            .email(intl.formatMessage({ id: 'validation.email' }))
            .required(intl.formatMessage({ id: 'validation.required' })).nullable(),
        contactPhone: Yup.string()
            .matches(phoneRegex, intl.formatMessage({ id: 'validation.phoneNumber' }))
            .matches(/^[+,0-9]+$/, intl.formatMessage({ id: 'validation.phoneNumber' }))
            .nullable(),
        postal: Yup.string()
            .matches(/^[0-9]+$/, intl.formatMessage({ id: 'validation.number' }))
            .min(5, intl.formatMessage({ id: 'validation.string.exact' }, [5]))
            .max(5, intl.formatMessage({ id: 'validation.string.exact' }, [5]))
            .nullable(),
        latitude: Yup.number()
            .required(intl.formatMessage({ id: 'validation.required' }))
            .typeError(intl.formatMessage({ id: 'validation.number' })),
        longtitude: Yup.number()
            .required(intl.formatMessage({ id: 'validation.required' }))
            .typeError(intl.formatMessage({ id: 'validation.number' })),
    });
